const buildClasses = (classArray) => {
    const mappedClasses = classArray.map((classObj) => {
        if (Array.isArray(classObj)) {
            const [
                classCheck,
                classString,
            ] = classObj;
            return classCheck ? classString : '';
        }
        return classObj;
    });
    return mappedClasses.join(' ');
};

export default buildClasses;
